import React from 'react'
import UserResult from '../components/Users/UserResult'
import UserSearch from '../components/Users/UserSearch'

function Home() {
  return (
    <>
        <UserSearch />
        <UserResult />
    </>
  )
}

export default Home